import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { useFetchSingleMenu } from '@entities/Menu'

import { useFeedbackModal } from '@features/feedback'

import { AppLink } from '@widgets/app-link'
import { AppMarket } from '@widgets/app-market'
import { PaymentSystems } from '@widgets/payment-systems'
import { SocialList } from '@widgets/social-list'


import { CONTACTS, URL_PAGE_AGREEMENT, URL_PAGE_POLICY } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import { LocalizedLink as Link } from '@shared/lib/locale'
import Button from '@shared/ui/button'
import Container from '@shared/ui/container'


import styles from './styles.module.scss'

export default function Footer () {
  const { t: tn } = useTranslation('navigation')
  const { t: tc } = useTranslation('common')
  const { openFeedbackModal } = useFeedbackModal()
  const { menu: aboutCompanyMenu } = useFetchSingleMenu('footer-about-company')
  const { menu: toCustomerMenu } = useFetchSingleMenu('footer-to-customer')

  const menus = [
    { menu: aboutCompanyMenu, title: 'about_company' },
    { menu: toCustomerMenu, title: 'to_buyer' },
  ]

  return (
    <footer className={styles.root}>
      <Container>
        <div className={styles.root__inner}>
          <div className={styles.root__top}>
            <nav className={styles.root__nav}>
              {menus.map((item, index) => {
                if (!item.menu) return null
                return (
                  <div className={styles['root__nav-group']} key={index}>
                    <h3 className={styles['root__title']}>{tn(item.title)}</h3>
                    <ul className={cn('reset-list', styles['root__nav-list'])}>
                      {item.menu.menuItems
                        ?.filter((menuItem) => menuItem.is_active)
                        .sort((a, b) => a.sort_order - b.sort_order)
                        .map((menuItem) => {
                          return (
                            <li className={styles['root__nav-item']} key={menuItem.id}>
                              <Link
                                className={styles['root__nav-link']}
                                to={menuItem.link_url}
                              >
                                {menuItem.title}
                              </Link>
                            </li>
                          )
                        })}
                    </ul>
                  </div>
                )
              })}
            </nav>

            <div className={styles.root__contacts}>
              <h3 className={styles.root__title}>{tc('contacts.title')}</h3>

              <div>
                <a className={styles.root__phone} href={`tel:${CONTACTS.phone}`}>
                  {CONTACTS.phone}
                </a>
              </div>

              <h3 className={styles.root__title}>{tc('contacts.support')}</h3>

              <div>
                <a
                  className={styles.root__email}
                  href={'mailto:' + CONTACTS.email}
                >
                  {CONTACTS.email}
                </a>
              </div>

              <div className={styles.root__feedback}>
                <h3 className={cn(styles.root__title, styles._feedback)}>
                  {tc('contacts.feedback')}
                </h3>
                <Button
                  className={styles['root__feedback-button']}
                  theme="secondary"
                  onClick={openFeedbackModal}
                >
                  {tc('feedback.button')}
                </Button>
              </div>
            </div>

            <div className={styles.root__app}>
              <h3 className={cn(styles.root__title, styles['root__app-title'])}>
                {tc('app.title')}
              </h3>
              <AppLink />
              <AppMarket />
            </div>

            <div className={styles.root__payments}>
              <h3 className={cn(styles.root__title, styles._subtitle)}>
                {tc('payments.systems')}
              </h3>
              <PaymentSystems />
            </div>

            <div className={styles.root__social}>
              <h3 className={cn(styles.root__title, styles._subtitle)}>
                {tc('social.title')}
              </h3>
              <SocialList />
            </div>
          </div>

          <div className={styles.root__bottom}>
            <p
              className={cn(styles['root__bottom-text'], styles['_copyright'])}
            >
              ©{format(new Date(), 'yyyy')}. {tc('footer.shop')}{' '}
            </p>
            <Link to={URL_PAGE_AGREEMENT} className={styles['root__bottom-text']}>
              {tc('user.agreement')}
            </Link>
            <Link
              to={URL_PAGE_POLICY}
              className={cn(styles['root__bottom-text'], styles['_policy'])}
            >
              {tc('privacy.policy')}
            </Link>
            <a
              href="https://hive-software.com"
              target="_blank"
              rel="noopener noreferrer"
              className={cn(styles['root__bottom-text'], styles['_powered'])}
            >
              Powered by HIVE Software
            </a>
          </div>
        </div>
      </Container>
    </footer>
  )
}
